/**
 * authQueryForImg — Feb 2026
 *
 * Backend endpoints that stream binary (photos, video) let clients pass a
 * JWT via `?auth=<token>` when the request comes from an `<img>`, `<video>`
 * or `<iframe>` (where custom Authorization headers aren't attachable).
 * `mediaSrc(path)` returns the fully-qualified absolute URL with the
 * token already appended, ready to drop into an `<img src>`.
 *
 * Consumers use it like:
 *   <img src={mediaSrc(album.cover.url)} />
 *
 * It reads the token from localStorage under the same key as api.js
 * (`co_token`). When no token is present the URL is returned unauthenticated
 * so debugging / share-link flows still resolve if the endpoint allows it.
 */
const BACKEND = (typeof process !== "undefined" && process.env && process.env.REACT_APP_BACKEND_URL) || "";

export function authQueryForImg() {
  const t = typeof window !== "undefined" ? localStorage.getItem("co_token") : null;
  return t ? `?auth=${encodeURIComponent(t)}` : "";
}

export function mediaSrc(path) {
  if (!path) return "";
  // Path already carries the /api/v1 prefix from the backend response.
  const q = authQueryForImg();
  const sep = path.includes("?") ? "&" : "?";
  const abs = path.startsWith("http") ? path : `${BACKEND}${path}`;
  return `${abs}${q ? sep + q.slice(1) : ""}`;
}

export default authQueryForImg;

